//status = -1, error, 0 - processing, 1 - processed - tinyint - ApiSyncStatus.php
import * as apiStatus from "@/helpers/apiStatus";

export const PROCESSING = 0;
export const PROCESSED = 1;
export const IMPORTED = 2;
export const ERROR = -1;
export const NO_CONTENT = -2;


export function syncData(context, api_sync_status) {
    let data = {
        color: 'text-secondary',
        text: context.$t('tools.import.sync_requested')
    };

    //if no response yet
    if (!api_sync_status) {
        return data;
    }

    switch (api_sync_status.status) {
        case apiStatus.PROCESSING: //0
            data = {
                color: 'text-secondary',
                text: context.$t('tools.import.sync_requested')
            }
            break;
        case apiStatus.PROCESSED: //1
            data = {
                color: 'text-primary',
                text: context.$t('tools.import.sync_progress')
            }
            break;
        case apiStatus.IMPORTED: //2
            data = {
                color: 'text-success',
                text: context.$t('tools.import.syn_last_time', {
                    dateTime: api_sync_status.updated_at
                })
            }
            break;
        case apiStatus.ERROR: //-1
            data = {
                color: 'text-danger',
                text: context.$t('tools.import.sync_failed', {
                    dateTime: api_sync_status.updated_at
                })
            }
            break;
        case apiStatus.NO_CONTENT: //-2
            data = {
                color: 'text-warning',
                text: context.$t('tools.import.sync_no_content', {
                    dateTime: api_sync_status.updated_at
                })
            }
            break;
    }

    return data;
}
